import React from 'react';
import Image from '@/components/common/Image';
import { BlogPost } from '@/data/blogPosts';

interface BlogPostHeaderProps {
  post: BlogPost;
}

const BlogPostHeader: React.FC<BlogPostHeaderProps> = ({ post }) => {
  return (
    <div className="relative mb-12 h-[500px] w-full overflow-hidden rounded-3xl shadow-lg">
      <Image
        src={post.imageUrl}
        alt={post.title}
        fill
        className="object-cover"
      />
      <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/40 to-transparent"></div>

      <div className="absolute inset-0 flex flex-col justify-end p-10 pb-16">
        <div className="flex">
          <span className="text-white text-sm mb-3 inline-block px-4 py-1.5 bg-black/30 backdrop-blur-sm rounded-full">
            {post.category}
          </span>
        </div>
        <h1 className="text-white text-5xl mb-4">{post.title}</h1>
        <p className="text-white/90 text-xl mb-8 max-w-3xl">{post.excerpt}</p>

        <div className="flex items-center">
          <div className="flex items-center space-x-3 mr-6">
            <div className="h-10 w-10 overflow-hidden rounded-full">
              <Image
                src={post.author.imageUrl}
                alt={post.author.name}
                width={40}
                height={40}
              />
            </div>
            <span className="text-white text-sm">{post.author.name}</span>
          </div>
          <div className="text-white/80 text-sm">
            {post.date} • {post.readTime}
          </div>
        </div>
      </div>
    </div>
  );
};

export default BlogPostHeader;
